import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { WixLinkUtilsService } from './linkUtilsService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(WixLinkUtilsService)
}

export const editor = site
